export const DateFilterTimespan = {
    LAST_WEEK: 'LAST_WEEK',
    LAST_MONTH: 'LAST_MONTH',
    NEXT_MONTH: 'NEXT_MONTH',
    NEXT_ONE_TO_THREE_MONTHS: 'NEXT_ONE_TO_THREE_MONTHS',
    NEXT_THREE_TO_SIX_MONTHS: 'NEXT_THREE_TO_SIX_MONTHS',
    NEXT_SIX_TO_TWELVE_MONTHS: 'NEXT_SIX_TO_TWELVE_MONTHS',
    OVER_ONE_YEAR_IN_FUTURE: 'OVER_ONE_YEAR_IN_FUTURE',
    NO_DATE: 'NO_DATE'
};
